module.exports = {
      id: "c2d4cd31805facc318bb695a144eb4dctoiletEquipment-none.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#c2d4cd31805facc318bb695a144eb4dctoiletEquipment-none.svg",
      toString: function () {
        return this.url;
      }
    }